import { USER_AVATARS_BUCKET } from '../constants/user-avatars';
import { buildPublicStorageObjectUrl } from './build-public-storage-object-url';

/** ユーザーアバターの公開 URL。未設定は null。 */
export function buildUserAvatarPublicUrl(
  supabaseUrl: string,
  avatarPath: string | null | undefined,
  avatarUpdatedAt?: string | Date | null,
): string | null {
  return buildPublicStorageObjectUrl(
    supabaseUrl,
    USER_AVATARS_BUCKET,
    avatarPath,
    avatarUpdatedAt,
  );
}
